import React, { useEffect, useState } from 'react'
import {
  Button,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import Icon from '@mdi/react'
import {
  mdiAccountSearch,
  mdiFilterMultiple,
  mdiMagnify,
  mdiNoteEditOutline,
} from '@mdi/js'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import BaseFilter from '../../../../components/hooks/BaseFilter'
import {
  renderRoute,
  renderRouteRole,
  useQueryParams,
} from '../../../../util/utils'
import colors from '../../../../assets/colors'
import { useSelector } from 'react-redux'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { format, isValid, parse, parseISO } from 'date-fns'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

const Filter = ({}) => {
  const location = useLocation()
  const history = useHistory()
  const filters = useQueryParams(location.search)

  const triggers = useSelector(state => state.crmPanel.triggers)
  const styles = filterStylesComponents()

  const [filter, setFilter] = useState({
    limit_date: new Date(),
  })

  const handleChangeDate = date => {
    setFilter({
      ...filter,
      limit_date: date,
    })
  }

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const hanldeSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)

    data.append('date_end', format(filter?.limit_date, 'yyyy-MM-dd'))

    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  useEffect(() => {
    const verifyQueryParam = () => {
      if (!filters.limit_date)
        return setFilter({ ...filters, limit_date: new Date() })

      setFilter({
        ...filter,
        limit_date: parse(filters?.limit_date, 'dd/MM/yyyy', new Date()),
      })
    }
    verifyQueryParam()
  }, [location])

  return (
    <BaseFilter>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <form
            style={{ width: '100%', height: '100%' }}
            onSubmit={hanldeSubmit}
          >
            <Grid container spacing={2}>
              <Grid item sm={4} md={3}>
                <Input
                  fullWidth
                  name="client"
                  style={{ marginTop: '16px' }}
                  defaultValue={filters?.client || ''}
                  id="standard-adornment-person"
                  placeholder="Pesquise por cliente"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton aria-label="search person" type="submit">
                        <Icon path={mdiAccountSearch} size={1} />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </Grid>
              <Grid item sm={4} md={2}>
                <TextField
                  type="number"
                  name="os"
                  variant="standard"
                  fullWidth
                  defaultValue={filters?.os}
                  label="Pesquise por os"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  select
                  name="trigger_id"
                  variant="standard"
                  fullWidth
                  label="Filtre por tipo"
                  defaultValue={filters?.trigger_id}
                >
                  <MenuItem value="">Selecione...</MenuItem>

                  {triggers?.map((trigger, index) => (
                    <MenuItem value={trigger?.id} key={index}>
                      {trigger?.reason}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <KeyboardDatePicker
                  clearable
                  label="Data Limite"
                  fullWidth
                  value={filter.limit_date}
                  onChange={handleChangeDate}
                  name="limit_date"
                  views={['date']}
                  clearLabel="Limpar"
                  invalidDateMessage="Data inválida"
                  autoOk
                  format="dd/MM/yyyy"
                />
              </Grid>

              <Grid item xs container alignItems="flex-end">
                <Button className={styles.btnMoreFilters} type="submit">
                  <Icon
                    path={mdiFilterMultiple}
                    size={1}
                    color={colors.secondary}
                  />
                  {` Filtrar`}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}

export default Filter
